import { render, staticRenderFns } from "./rich-text-description-label.vue?vue&type=template&id=3b4b8ed6&scoped=true"
import script from "./rich-text-description-label.vue?vue&type=script&lang=js"
export * from "./rich-text-description-label.vue?vue&type=script&lang=js"
import style0 from "./rich-text-description-label.vue?vue&type=style&index=0&id=3b4b8ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b8ed6",
  null
  
)

export default component.exports